import React from 'react';
import PropTypes from 'prop-types';
import { CopyableText } from 'modules/Common/Copy';

const getInternationalPrefix = (country, zipcode) => {
  if (!country || !zipcode || typeof zipcode !== 'string') return null;

  return `${country} ${zipcode.slice(0, 2)} `;
};

const AddressLabelCell = ({ addressLabel, isInternational, stopCountry, stopZipcode }) => {
  const internationalPrefix = isInternational && getInternationalPrefix(stopCountry, stopZipcode);
  return (
    <div title={addressLabel}>
      <CopyableText text={`${isInternational ? internationalPrefix : ''}${addressLabel}`} />
    </div>
  );
};

AddressLabelCell.propTypes = {
  addressLabel: PropTypes.string,
  isInternational: PropTypes.bool,
  stopCountry: PropTypes.string,
  stopZipcode: PropTypes.string,
};

export default AddressLabelCell;
